<template>
<span v-if="typeof user !== 'object'">user</span>
<a v-else-if="!user.props.deleted" class="name"
	:class="[
		'user-'+user.props.id
	]"
	:data-content="user.props.name"
	:data-name="user.props.name"
	:style="{ '--color1': '#'+user.props.color[0], '--color2': '#'+user.props.color[1], '--color3': '#'+user.props.color[2] }"
>
	<span
		:class="{ 'two-color': user.props.color.length == 2, 'three-color': user.props.color.length == 3, 'vertical-fade': user.props.fade == 1, 'horizontal-fade': user.props.fade == 2, 'radial-fade': user.props.fade == 3}"
	>
		{{ (user.props.vanity || user.props.name) }}
	</span>
</a>
<a v-else-if="user.props.deleted" class="name"
	:data-content="user.props.name"
	:data-name="user.props.name"
>
	(deleted){{ user.props.name }}
	<a v-if="isOwnUser(account, user)" class="no-underline undelete" @click.prevent="undelete()">♲</a>
</a>
</template>

<script>
import socket from '../js/socket.js'
import account from '../js/account.js'
import accountFns from '../js/account-functions.js'

export default {
	props: {
		user: {
			type: [Number, Object],
			required: true
		}
	},
	data: () => ({
		account
	}),
	methods: {
		undelete: function(){
			socket.emit( 'undelete-char', {userid: this.user.props.id})
		},
		isOwnUser: accountFns.isOwnUser
	}
}
</script>